<template>
    <div class="modal-overlay" @click="handleOverlayClick">
      <div class="object-details" @click.stop>
        <button class="close-btn" @click="closeModal">×</button>
        <h2> {{ filteredObject.name}} Details</h2>
        <dl>
          <div v-for="(value, key) in filteredObject" :key="key">
            <dt>{{ key }}</dt>
            <dd>{{ value }}</dd>
          </div>
        </dl>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'HiloAdminDashboardLenderInfo.vue',
    props: {
      object: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        filteredObject: {}
      }
    },
    watch: {
      object: {
        handler(newObject) {
          this.filterObject(newObject);
        },
        deep: true, // This ensures the watcher reacts to changes in the nested properties of the object as well
      }
    },
    mounted() {
      this.filterObject(this.object);
    },
    methods: {
      filterObject(object) {
        const filtered = {};
        Object.keys(object).forEach(key => {
          const value = object[key];
          if (value !== null && value !== undefined && value !== '') {
            filtered[key] = value;
          }
        });
        this.filteredObject = filtered;
      },
      closeModal() {
        this.$emit('close');
      },
      handleOverlayClick(event) {
        // Close modal if click is outside the modal content
        if (event.target === event.currentTarget) {
          this.closeModal();
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5); /* Slightly darken the background */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    overflow: auto;
  }
  
  .object-details {
    max-width: 600px;
    max-height: 80vh;
    overflow-y: auto; /* Allow vertical scrolling */
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 20px;
    width: 100%;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    position: relative;
  }
  
  .close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 24px;
    color: red;
    background: none;
    border: none;
    cursor: pointer;
  }
  
  dl {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 8px;
  }
  
  dt {
    font-weight: bold;
  }
  
  dd {
    margin-left: 0;
  }
  </style>
  